"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var theme = {
    name: 'fearlessBusiness',
    borders: {},
    borderStyles: {},
    borderWidths: [],
    breakpoints: [768],
    colors: {
        get background() {
            return this.white;
        },
        get title() {
            return this.secondary;
        },
        get body() {
            var _a;
            return (_a = this.neutral) === null || _a === void 0 ? void 0 : _a[600];
        },
        // Core colours / Business
        primary: {
            lightest: '#D0EEFD',
            lighter: '#AEDEFF',
            light: '#86D1FF',
            main: '#6EC8FF',
            medium: '#124099',
            dark: '#1A0826',
        },
        // Core colours / Confidence
        secondary: '#1A0826',
        get tertiary() {
            var _a;
            return (_a = this.neutral) === null || _a === void 0 ? void 0 : _a[500];
        },
        get accent() {
            var _a;
            return (_a = this.primary) === null || _a === void 0 ? void 0 : _a.medium;
        },
        // Core colours / Control
        muted: '#FFFFFA',
        // Neutrals + Greys
        neutral: {
            0: '#F8F8F9',
            50: '#F3F1F1',
            100: '#E7E4E4',
            200: '#E0DEE0',
            300: '#C2C0C2',
            400: '#959196',
            500: '#4C5A69',
            600: '#2D3347',
        },
        success: '#1F7A39',
        successLight: '#CFF4DB',
        info: '#0D5ED9',
        infoLight: '#D8E7FD',
        warning: '#995700',
        warningLight: '#FEEDD8',
        danger: '#B00020',
        dangerLight: '#FEEFEC',
        white: '#fff',
        black: '#000',
    },
    fonts: {
        title1: {
            family: '"Sharp Grotesk 25"',
            weight: 500,
            size: polished_1.rem(40),
            letterSpacing: polished_1.rem(0),
            lineHeight: polished_1.rem(46),
        },
        title2: {
            family: '"Sharp Grotesk 25"',
            weight: 500,
            size: polished_1.rem(32),
            letterSpacing: polished_1.rem(0),
            lineHeight: polished_1.rem(40),
        },
        title3: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(28),
            letterSpacing: polished_1.rem(0),
            lineHeight: polished_1.rem(34),
        },
        title4: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(26),
            letterSpacing: polished_1.rem(0.2),
            lineHeight: polished_1.rem(32),
        },
        heading1: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(20),
            letterSpacing: polished_1.rem(0.3),
            lineHeight: polished_1.rem(26),
        },
        heading2: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(18),
            letterSpacing: polished_1.rem(0.5),
            lineHeight: polished_1.rem(24),
        },
        heading3: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(15),
            letterSpacing: polished_1.rem(0.5),
            lineHeight: polished_1.rem(24),
        },
        heading4: {
            family: '"Sharp Grotesk"',
            weight: 400,
            size: polished_1.rem(15),
            letterSpacing: polished_1.rem(0.4),
            lineHeight: polished_1.rem(22),
        },
        body1: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(14),
            letterSpacing: polished_1.rem(0.5),
            lineHeight: polished_1.rem(21),
        },
        body2: {
            family: '"Sharp Grotesk"',
            weight: 400,
            size: polished_1.rem(14),
            letterSpacing: polished_1.rem(0.4),
            lineHeight: polished_1.rem(21),
        },
        body3: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(11),
            letterSpacing: polished_1.rem(0.4),
            lineHeight: polished_1.rem(18),
        },
        body4: {
            family: '"Sharp Grotesk"',
            weight: 400,
            size: polished_1.rem(11),
            letterSpacing: polished_1.rem(0.4),
            lineHeight: polished_1.rem(18),
        },
        caption1: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(10),
            letterSpacing: polished_1.rem(0.4),
            lineHeight: polished_1.rem(16),
        },
        caption2: {
            family: '"Sharp Grotesk"',
            weight: 400,
            size: polished_1.rem(10),
            letterSpacing: polished_1.rem(0.4),
            lineHeight: polished_1.rem(16),
        },
        caption3: {
            family: '"Sharp Grotesk"',
            weight: 500,
            size: polished_1.rem(8),
            letterSpacing: polished_1.rem(0.4),
            lineHeight: polished_1.rem(12),
        },
        caption4: {
            family: '"Sharp Grotesk"',
            weight: 400,
            size: polished_1.rem(8),
            letterSpacing: polished_1.rem(0.4),
            lineHeight: polished_1.rem(12),
        },
    },
    fontSizes: {
        title1: polished_1.rem(40),
        title2: polished_1.rem(32),
        title3: polished_1.rem(28),
        title4: polished_1.rem(26),
        heading1: polished_1.rem(20),
        heading2: polished_1.rem(18),
        heading3: polished_1.rem(15),
        heading4: polished_1.rem(15),
        body1: polished_1.rem(14),
        body2: polished_1.rem(14),
        body3: polished_1.rem(11),
        body4: polished_1.rem(11),
        caption1: polished_1.rem(10),
        caption2: polished_1.rem(10),
        caption3: polished_1.rem(8),
        caption4: polished_1.rem(8),
    },
    fontWeights: {
        light: 300,
        normal: 400,
        medium: 500,
    },
    letterSpacings: {
        title1: polished_1.rem(0),
        title2: polished_1.rem(0),
        title3: polished_1.rem(0),
        title4: polished_1.rem(0.2),
        heading1: polished_1.rem(0.3),
        heading2: polished_1.rem(0.5),
        heading3: polished_1.rem(0.5),
        heading4: polished_1.rem(0.4),
        body1: polished_1.rem(0.5),
        body2: polished_1.rem(0.4),
        body3: polished_1.rem(0.4),
        body4: polished_1.rem(0.4),
        caption1: polished_1.rem(0.4),
        caption2: polished_1.rem(0.4),
        caption3: polished_1.rem(0.4),
        caption4: polished_1.rem(0.4),
    },
    lineHeights: {
        title1: polished_1.rem(46),
        title2: polished_1.rem(40),
        title3: polished_1.rem(34),
        title4: polished_1.rem(32),
        heading1: polished_1.rem(26),
        heading2: polished_1.rem(24),
        heading3: polished_1.rem(24),
        heading4: polished_1.rem(22),
        body1: polished_1.rem(21),
        body2: polished_1.rem(21),
        body3: polished_1.rem(18),
        body4: polished_1.rem(18),
        caption1: polished_1.rem(16),
        caption2: polished_1.rem(16),
        caption3: polished_1.rem(12),
        caption4: polished_1.rem(12),
    },
    opacities: [],
    radii: {
        sm: '2px',
        md: '4px',
        lg: '8px',
    },
    shadows: {},
    sizes: {
        full: '100%',
        screenHeight: '100vh',
        screenWidth: '100vw',
    },
    space: [0, 4, 8, 16, 24, 32].map(function (space) { return space + "px"; }),
    transitions: {},
    zIndices: {},
};
exports.default = theme;
